import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Logout from '@mui/icons-material/Logout'
import Settings from '@mui/icons-material/Settings'
import {
    AppBar,
    Box,
    Button,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Toolbar,
} from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { getUserProfile, logout } from '../services/authService'

type HeaderProps = {
    navigationVisible: boolean
    setNavigationVisible: React.Dispatch<React.SetStateAction<boolean>>
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Header = ({ navigationVisible, setNavigationVisible }: HeaderProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const handleClose = () => {
        setAnchorEl(null)
    }
    const getNickName = () => {
        const profile = getUserProfile()
        if (profile?.nickname?.startsWith('0x')) {
            return profile?.nickname?.substring(profile.nickname.length - 5)
        }
        return profile?.nickname
    }
    const navigate = useNavigate()
    const logoutClick = () => {
        logout()
        window.location.href = `${url()}/oauth/logout`
    }

    const url = () =>
        process.env.REACT_APP_NODE_ENV === 'localhost' ? process.env.REACT_APP_HOST_REDIRECT : ''

    return (
        <AppBar position="relative" elevation={0} color="transparent">
            <Toolbar>
                <Box style={{ flexGrow: 1 }} />
                <Button
                    variant="outlined"
                    size="large"
                    style={{ backgroundColor: 'transparent' }}
                    startIcon={<AccountCircleIcon />}
                    endIcon={<ExpandMoreIcon />}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                >
                    {getNickName()}
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    PaperProps={{
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&:before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    <MenuItem onClick={logoutClick}>
                        <ListItemIcon>
                            <Logout />
                        </ListItemIcon>
                        <ListItemText primary="Logout" />
                    </MenuItem>
                    <MenuItem onClick={() => navigate('/settings')}>
                        <ListItemIcon>
                            <Settings />
                        </ListItemIcon>
                        <ListItemText primary="Settings" />
                    </MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    )
}
